import * as Dialog from '@radix-ui/react-dialog';

import ContactEdit from '../CandidateForm/ContactEdit';
import RegisterEdit from '../CandidateForm/RegisterEdit';
import PersonalData1 from '../CandidateForm/PersonalData1';
import PersonalData2 from '../CandidateForm/PersonalData2';
import ProfessionalData1 from '../CandidateForm/ProfessionalData1';
import ProfessionalData2 from '../CandidateForm/ProfessionalData2';
import ProfessionalDataEducation from '../CandidateForm/ProfessionalDataEducation';
import ProfessionalData4 from '../CandidateForm/ProfessionalData4';
import ProfessionalDataExperience from '../CandidateForm/ProfessionalDataExperience';
import DisabilityDataIndex from '../CandidateForm/DisabilityDataIndex';
import DisabilityData from '../CandidateForm/DisabilityData';
import DisabilityDataDescription from '../CandidateForm/DisabilityDataDescription';
import DisabilityDataUpload from '../CandidateForm/DisabilityDataUpload';
import DeleteAccount from './DeleteAccount';
import Icon from '@egalite/ui/Icon';

import { useParams, usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import Button from '@egalite/ui/Buttons';
import Typography from '@egalite/ui/Typography';

const EditDialog = ({ fetchCandidate = () => {}, message = null }) => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const pathname = usePathname();
	const [isFormValid, setIsFormValid] = useState(true);
	const [isRegisterModal, setIsRegisterModal] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [showValidationMessage, setShowValidationMessage] = useState(false);

	const redirectOnClose = searchParams.get('redirectOnClose') ?? null;
	const modalParam = searchParams.get('modal');
	// `closable=1` (fluxo de requisitos da candidatura) mantém o modal de register fechável:
	// ali o candidato pode desistir e continuar na vaga.
	const closableParam = searchParams.get('closable');

	// Verificar se é o modal de register e controlar o estado do dialog
	useEffect(() => {
		const isRegister = modalParam === 'register' && closableParam !== '1';
		setIsRegisterModal(isRegister);
		setDialogOpen(modalParam != null);
		// Se for o modal de register, começar com formulário inválido até que seja validado
		if (isRegister) {
			setIsFormValid(false);
		}
	}, [modalParam, closableParam]);

	const closeModal = useCallback(() => {
		const params = new URLSearchParams(searchParams.toString());
		params.delete('modal');
		params.delete('id');
		params.delete('closable');
		router.replace(`${pathname}?${params.toString()}`);
	}, [pathname, router, searchParams]);

	const mapForms = useMemo(
		() => ({
			contact: () => (
				<ContactEdit
					//@ts-ignore
					edit={true}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
            register: () => (
				<RegisterEdit
					//@ts-ignore
					edit={true}
					onFormValidChange={(isValid) => {
						setIsFormValid(isValid);
						// Quando o formulário se torna válido, permitir fechamento
						if (isValid) {
							setDialogOpen(true);
						}
					}}
					onSuccess={() => {
						setIsFormValid(true); // Garantir que está válido após sucesso
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			personal1: () => (
				<PersonalData1
					//@ts-ignore
					edit={true}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			personal2: () => (
				<PersonalData2
					//@ts-ignore
					edit={true}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			professional1: () => (
				<ProfessionalData1
					edit={true}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			professional2: () => (
				<ProfessionalData2
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			professional4: () => (
				<ProfessionalData4
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			education: () => (
				<ProfessionalDataEducation
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			experience: () => (
				<ProfessionalDataExperience
					edit={true}
					//@ts-ignore
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			disabilityIndex: () => (
				<DisabilityDataIndex
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			disability: () => (
				<DisabilityData
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			disabilityDescription: () => (
				<DisabilityDataDescription
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							closeModal();
							fetchCandidate();
						}
					}}
				/>
			),
			disabilityUpload: () => (
				<DisabilityDataUpload
					edit={true}
					//@ts-ignore
					root={pathname}
					onSuccess={() => {
						if(redirectOnClose != null) {
							router.push(redirectOnClose);
						} else {
							// Redireciona para a rota do currículo onde o banner funciona corretamente
							// Usar replace para evitar problema de cache do banner 
							window.location.href = '/candidato/curriculo';
						}
					}}
				/>
			),
			'delete-account': () => <DeleteAccount onCancel={closeModal} />,
		}),
		[closeModal, fetchCandidate, pathname, redirectOnClose, router],
	);

	return (
		<Dialog.Root
			open={dialogOpen}
			onOpenChange={open => {
				if (open === false) {
					// Modal "Complete seu perfil": só fecha ao clicar em Salvar (nunca por clique fora ou Escape)
					if (isRegisterModal) {
						setDialogOpen(true);
						if (!isFormValid) {
							setShowValidationMessage(true);
							setTimeout(() => setShowValidationMessage(false), 3000);
						}
						return;
					}
					setShowValidationMessage(false);
					setDialogOpen(false);
					if (redirectOnClose != null) {
						router.push(redirectOnClose);
					} else {
						closeModal();
					}
				} else {
					setDialogOpen(open);
				}
			}}
		>
			<Dialog.Overlay className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 z-40" />
			<Dialog.Content
				className="fixed mt-10 mb-4 left-1/2 -translate-x-1/2 bg-white rounded-3xl pt-10 md:mt-0 md:mb-14 w-11/12 max-w-6xl z-50"
				onPointerDownOutside={e => {
					// Modal "Complete seu perfil": não fecha ao clicar fora; só ao clicar em Salvar
					if (isRegisterModal) {
						e.preventDefault();
						if (!isFormValid) {
							setShowValidationMessage(true);
							setTimeout(() => setShowValidationMessage(false), 3000);
						}
					}
				}}
				onInteractOutside={e => {
					if (isRegisterModal) {
						e.preventDefault();
					}
				}}
				onEscapeKeyDown={e => {
					if (isRegisterModal) {
						e.preventDefault();
						if (!isFormValid) {
							setShowValidationMessage(true);
							setTimeout(() => setShowValidationMessage(false), 3000);
						}
					}
				}}
			>
				{showValidationMessage && isRegisterModal && !isFormValid && (
					<div className="bg-error-light border-l-4 border-error-main p-4 mb-4 mx-4 rounded">
						<Typography variant="body2" className="text-error-dark">
							Por favor, preencha todos os campos obrigatórios e clique em Salvar para continuar.
						</Typography>
					</div>
				)}
				<div className="overflow-x-hidden overflow-y-auto w-full max-h-[calc(100dvh-60px)] md:max-h-[calc(100dvh-140px)]">
                    {message ? <Typography  variant="headline-4" className="p-12 mt-8 mb-8">{message}</Typography> : null}
					{mapForms[searchParams.get('modal')] != null && mapForms[searchParams.get('modal')]()}
				</div>
				{/* Modal "Complete seu perfil": sem botão de fechar; usuário só sai após Salvar com todos os campos preenchidos */}
				{!isRegisterModal && (
					<Dialog.Close asChild>
						<Button
							variant="secondary"
							type="button"
							className="rounded-full p-2 w-20 h-20 bg-white fixed -right-4 sm:-right-8 -top-8 z-[51] border-2"
						>
							<Icon className="fi fi-br-cross" />
						</Button>
					</Dialog.Close>
				)}
			</Dialog.Content>
		</Dialog.Root>
	);
};

export default EditDialog;
